/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import './address';
import './line_item';
import '../../common/currency';
import '../../common/location';
import './carton';
import './user_facing_status';
import './return_authorization';
import './sq_installment_plan';
import '../../common/countries';
import './order_cancellation_status';
import './sq_shipping_quote';
import './tax_adjustment';
import './payment_detail';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "Order": {
                "fields": {
                  "number": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.solidshop.model.Order.Type",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "placedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.solidshop.model.Order.State",
                    "id": 5,
                    "rule": "optional"
                  },
                  "paymentState": {
                    "type": "squareup.solidshop.model.Order.PaymentState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "shipmentState": {
                    "type": "squareup.solidshop.model.Order.ShipmentState",
                    "id": 7,
                    "rule": "optional"
                  },
                  "userId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "legacyUserModelToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": "squareup.solidshop.model.Address",
                    "id": 12,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": "squareup.solidshop.model.Address",
                    "id": 13,
                    "rule": "optional"
                  },
                  "lineItem": {
                    "type": "squareup.solidshop.model.LineItem",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "totalPriceMoney": {
                    "type": "squareup.common.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "paymentSchedule": {
                    "type": "squareup.solidshop.model.Order.PaymentSchedule",
                    "id": 16,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "phoneNumber": {
                    "type": "squareup.common.location.Phone",
                    "id": 18,
                    "rule": "optional"
                  },
                  "itemTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 19,
                    "rule": "optional"
                  },
                  "promoTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 20,
                    "rule": "optional"
                  },
                  "additionalTaxTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 21,
                    "rule": "optional"
                  },
                  "includedTaxTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 22,
                    "rule": "optional"
                  },
                  "shipmentTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 23,
                    "rule": "optional"
                  },
                  "adjustmentTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 24,
                    "rule": "optional"
                  },
                  "paymentTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 25,
                    "rule": "optional"
                  },
                  "carton": {
                    "type": "squareup.solidshop.model.Carton",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "userFacingStatus": {
                    "type": "squareup.solidshop.model.OrderUserFacingStatus.UserFacingStatus",
                    "id": 27,
                    "rule": "optional"
                  },
                  "sqSource": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 29,
                    "rule": "optional"
                  },
                  "sqCustomerCardId": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "sqCustomerId": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "cancellable": {
                    "type": "bool",
                    "id": 32,
                    "rule": "optional"
                  },
                  "returnAuthorization": {
                    "type": "squareup.solidshop.model.ReturnAuthorization",
                    "id": 33,
                    "rule": "repeated"
                  },
                  "sqInstallmentPlan": {
                    "type": "squareup.solidshop.model.SqInstallmentPlan",
                    "id": 34,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 35,
                    "rule": "optional"
                  },
                  "orderCancellationStatus": {
                    "type": "squareup.solidshop.model.OrderCancellationStatus",
                    "id": 36,
                    "rule": "optional"
                  },
                  "sqAvt": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  },
                  "lastIpAddress": {
                    "type": "string",
                    "id": 38,
                    "rule": "optional"
                  },
                  "approvedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 39,
                    "rule": "optional"
                  },
                  "rejectedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 40,
                    "rule": "optional"
                  },
                  "sqShared": {
                    "type": "bool",
                    "id": 41,
                    "rule": "optional"
                  },
                  "sqInternal": {
                    "type": "bool",
                    "id": 42,
                    "rule": "optional"
                  },
                  "sqInternalType": {
                    "type": "squareup.solidshop.model.Order.SqInternalType",
                    "id": 43,
                    "rule": "optional"
                  },
                  "eligibleFinanceableAmount": {
                    "type": "squareup.common.Money",
                    "id": 44,
                    "rule": "optional"
                  },
                  "sqGuestCheckout": {
                    "type": "bool",
                    "id": 45,
                    "rule": "optional"
                  },
                  "isExpeditedShipping": {
                    "type": "bool",
                    "id": 46,
                    "rule": "optional"
                  },
                  "shipmentAdditionalTaxMoney": {
                    "type": "squareup.common.Money",
                    "id": 47,
                    "rule": "optional"
                  },
                  "shipmentIncludedTaxMoney": {
                    "type": "squareup.common.Money",
                    "id": 48,
                    "rule": "optional"
                  },
                  "shippingMethodName": {
                    "type": "string",
                    "id": 49,
                    "rule": "optional"
                  },
                  "shippingQuoteEstimate": {
                    "type": "squareup.solidshop.model.SqShippingQuote",
                    "id": 50,
                    "rule": "optional"
                  },
                  "sqLocale": {
                    "type": "string",
                    "id": 51,
                    "rule": "optional"
                  },
                  "itemTaxAdjustments": {
                    "type": "squareup.solidshop.model.TaxAdjustment",
                    "id": 52,
                    "rule": "repeated"
                  },
                  "shipmentTaxAdjustments": {
                    "type": "squareup.solidshop.model.TaxAdjustment",
                    "id": 53,
                    "rule": "repeated"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 54,
                    "rule": "optional"
                  },
                  "invoiceTo": {
                    "type": "string",
                    "id": 55,
                    "rule": "optional"
                  },
                  "shippingSpeed": {
                    "type": "squareup.solidshop.model.Order.ShippingSpeed",
                    "id": 56,
                    "rule": "optional"
                  },
                  "failedPaymentIds": {
                    "type": "string",
                    "id": 57,
                    "rule": "repeated"
                  },
                  "paymentDetails": {
                    "type": "squareup.solidshop.model.PaymentDetail",
                    "id": 58,
                    "rule": "repeated"
                  },
                  "pickupAddress": {
                    "type": "squareup.solidshop.model.Address",
                    "id": 59,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PaymentSchedule": {
                    "values": {
                      "UPFRONT": 1,
                      "INSTALLMENT": 2,
                      "PURCHASE_ORDER": 3
                    }
                  },
                  "PaymentState": {
                    "values": {
                      "BALANCE_DUE": 1,
                      "PAID": 2,
                      "CREDIT_OWED": 3,
                      "FAILED": 4,
                      "VOID": 5,
                      "PAYMENT_STATE_NIL": 6
                    }
                  },
                  "ShipmentState": {
                    "values": {
                      "NIL": 1,
                      "PENDING": 2,
                      "READY": 3,
                      "SHIPMENT_CANCELED": 4,
                      "SHIPPED": 5,
                      "PARTIAL": 6,
                      "BACKORDER": 7
                    }
                  },
                  "State": {
                    "values": {
                      "CART": 1,
                      "COMPLETE": 2,
                      "CANCELED": 3,
                      "RESUMED": 4,
                      "AWAITING_RETURN": 5,
                      "RETURNED": 6,
                      "CONFIRM": 7,
                      "EXPIRED": 8
                    }
                  },
                  "Type": {
                    "values": {
                      "NORMAL": 1,
                      "RETURN": 2,
                      "WARRANTY": 3,
                      "BLIND_RETURN": 4,
                      "WARRANTY_RETURN": 5
                    }
                  },
                  "SqInternalType": {
                    "values": {
                      "UNKNOWN": 1,
                      "SALES": 2,
                      "SUPPORTERS": 3
                    }
                  },
                  "ShippingSpeed": {
                    "values": {
                      "STANDARD": 0,
                      "OVERNIGHT": 1,
                      "TWO_DAY": 2,
                      "EXPRESS": 3,
                      "SAME_DAY": 4,
                      "FOUR_DAY": 5,
                      "NO_SHIP": 6,
                      "IN_STORE_PICKUP": 7
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.PaymentSchedule && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.PaymentState && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.ShipmentState && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.State && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.Type && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.SqInternalType && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.Order?.nested?.ShippingSpeed) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Order @ squareup/solidshop/model/order.proto at 24:1
 */
export const Order = $root.lookupType('squareup.solidshop.model.Order');
fixType(Order);
Builder.createAndAttachToType(Order);
/**
 * SOURCE PaymentSchedule @ squareup/solidshop/model/order.proto at 25:3
 */
Order.PaymentSchedule = $root.lookupEnum('squareup.solidshop.model.Order.PaymentSchedule').values;
/**
 * SOURCE PaymentState @ squareup/solidshop/model/order.proto at 32:3
 */
Order.PaymentState = $root.lookupEnum('squareup.solidshop.model.Order.PaymentState').values;
/**
 * SOURCE ShipmentState @ squareup/solidshop/model/order.proto at 46:3
 */
Order.ShipmentState = $root.lookupEnum('squareup.solidshop.model.Order.ShipmentState').values;
/**
 * SOURCE State @ squareup/solidshop/model/order.proto at 59:3
 */
Order.State = $root.lookupEnum('squareup.solidshop.model.Order.State').values;
/**
 * SOURCE Type @ squareup/solidshop/model/order.proto at 73:3
 */
Order.Type = $root.lookupEnum('squareup.solidshop.model.Order.Type').values;
/**
 * SOURCE SqInternalType @ squareup/solidshop/model/order.proto at 86:3
 */
Order.SqInternalType = $root.lookupEnum('squareup.solidshop.model.Order.SqInternalType').values;
/**
 * SOURCE ShippingSpeed @ squareup/solidshop/model/order.proto at 95:5
 */
Order.ShippingSpeed = $root.lookupEnum('squareup.solidshop.model.Order.ShippingSpeed').values;
